import * as preShopActions from '../actions/PreShops';

const initialState = {
  preShops: [],
  detail: {
    tags: [],
    preGochis: [],
    images: []
  },
  statuses: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'PRE_REGISTER',
      name: '仮登録'
    },
    {
      id: 'REGISTERED',
      name: '本登録済'
    }
  ],
  error: false,
  status: 200,
  error_message: '',
  preShopNames: {
    preShops: [],
    totalCount: 0
  },
  preShopPhones: {
    preShops: [],
    totalCount: 0
  }
};

const preShops = (state = initialState, action) => {
  switch (action.type) {
    case preShopActions.GET_PRE_SHOPS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case preShopActions.GET_PRE_SHOPS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case preShopActions.DOWNLOAD_PRE_SHOP_SUCCESS:
      return Object.assign({}, state, action.payload);
    case preShopActions.DOWNLOAD_PRE_SHOP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case preShopActions.GET_PRE_SHOP_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case preShopActions.GET_PRE_SHOP_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case preShopActions.CLEAR_PRE_SHOP_DETAIL:
      return Object.assign({}, state, {
        detail: { tags: [], preGochis: [], images: [] }
      });
    case preShopActions.EDIT_PRE_SHOP_SUCCESS:
      return Object.assign({}, state, { edit: action.payload });
    case preShopActions.EDIT_PRE_SHOP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case preShopActions.COUNT_PRE_SHOP_NAME_SUCCESS:
      return Object.assign({}, state, { preShopNames: action.payload });
    case preShopActions.COUNT_PRE_SHOP_NAME_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case preShopActions.COUNT_PRE_SHOP_PHONE_SUCCESS:
      return Object.assign({}, state, { preShopPhones: action.payload });
    case preShopActions.COUNT_PRE_SHOP_PHONE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default preShops;
